jQuery(document).ready(function($) {

    // Header Specific JS

    // Strip angle brackets in header top search before an accidental/pasted "<script>"-style
    // value can't reach the host's edge firewall and trip a raw 403 page;
    // the firewall itself is untouched.
    $('form.searchform--no-autocomplete').on('submit', function () {
        const $input = $(this).find('input[name="s"]');
        $input.val($input.val().replace(/[<>]/g, ''));
    });

    // Account login dropdown — only produces any elements to bind to on
    // sites that have Login Dropdown Links configured in Header Settings;
    // otherwise these selectors are empty and every handler below no-ops.
    $('.user-login-container.has-login-dropdown').each(function () {
        const $container = $(this);
        const $trigger = $container.find('button.user-login');

        $trigger.on('click', function (e) {
            e.preventDefault();
            const isOpen = $container.hasClass('is-open');
            $('.user-login-container.has-login-dropdown')
                .removeClass('is-open')
                .find('button.user-login')
                .attr('aria-expanded', 'false');
            if (!isOpen) {
                $container.addClass('is-open');
                $trigger.attr('aria-expanded', 'true');
            }
        });
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.user-login-container').length) {
            $('.user-login-container.has-login-dropdown')
                .removeClass('is-open')
                .find('button.user-login')
                .attr('aria-expanded', 'false');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $('.user-login-container.has-login-dropdown')
                .removeClass('is-open')
                .find('button.user-login')
                .attr('aria-expanded', 'false');
        }
    });

    /**
     * Mobile Menu Configuration
     * Using sidr to handle our menu JS
     * https://www.berriart.com/sidr/
     */

        // Configuration
    const sidrName = 'sidr-main';

    // Initialize mobile navigation
    $('.mobile-navigation #mobile-menu-toggle').sidr({
        name: sidrName,
        side: 'right',
        source: '.main-navigation, .menu-utility-menu-container, .user-login-container',
        renaming: false,
        onOpen: function () {
            // Rename only the primary-menu ID in the cloned sidr menu
            $('#' + sidrName + ' #primary-menu').attr('id', 'sidr-primary-menu');

            // Add click handler to close menu when clicking outside
            $(window).on('click.sidr', function () {
                $.sidr('close', sidrName);
            });

            // Update UI elements
            $('#mobile-menu-toggle').addClass('menu-open close mobile menu');
            $('body').append('<div class="mobile-menu-overlay"></div>');

            // Add click handler to close button
            $('#mobile-menu-toggle.close').click(function () {
                $.sidr('close', sidrName);
            });
        },
        onClose: function () {
            // Remove handlers and reset UI elements
            $(window).off('click.sidr');
            $('#mobile-menu-toggle').removeClass('menu-open close mobile menu');
            $('.mobile-menu-overlay').remove();
        },
    });

    // Prevent menu from closing when clicking inside it
    $('#' + sidrName).on('click.sidr', function (e) {
        e.stopPropagation();
    });

    // Add dropdown icon
    $('.menu-primary-container > .menu > li.menu-item-has-children > a').append(
        '<i class="fa-regular fa-angle-down"></i>'
    );

    // Handle submenu toggle on parent link click (two-click behavior)
    $('.sidr .menu-primary-container > .menu > li.menu-item-has-children > a').on(
        'click',
        function (e) {
            const $link = $(this);
            const $parent = $link.closest('li.menu-item-has-children');
            const isCurrentlyOpen = $parent.hasClass('open');
            const clickedIcon = $(e.target).is('i');

            // If submenu is closed, open it and prevent navigation
            if (!isCurrentlyOpen) {
                e.preventDefault();

                // Close all other submenus
                $('.sidr .menu-primary-container > .menu > li.menu-item-has-children')
                    .not($parent)
                    .removeClass('open')
                    .children('.sub-menu')
                    .slideUp();

                // Open current submenu
                $parent.addClass('open');
                $parent.children('.sub-menu').slideDown();

                return false;
            }

            // If submenu is already open and icon was clicked, close it
            if (clickedIcon) {
                e.preventDefault();
                $parent.removeClass('open');
                $parent.children('.sub-menu').slideUp();
                return false;
            }

            // If submenu is open and link text was clicked, allow navigation (default behavior)
        }
    );

    // Search
    // $('.search-form .searchsubmit').val('');
    $('.searchform .search-submit').val('');

    // Mobile search toggle
    $('.mobile-navigation .search-toggle').click(function (e) {
        e.preventDefault();
        $('.utility-navigation-container').toggleClass('search-active');
        $('.utility-navigation-container .searchform').toggleClass('search-active');
        $('.utility-navigation-container .searchform').toggle();
        $(this).toggleClass('active');
        if ($('.utility-navigation-container .searchform').hasClass('search-active')) {
            $('.utility-navigation-container .searchform input[name="s"]').focus();
        }
    });

    // Sticky donate button: show after scroll on mobile
    const $stickyDonateButton = $('.sticky-donate-button');
    if ($stickyDonateButton.length) {
        const $stickyDonateWindow = $(window);
        const desktopQuery = window.matchMedia('(min-width: 1100px)');
        const threshold =
            parseInt($stickyDonateButton.data('scroll-threshold'), 10) || 200;

        const maybeShowStickyDonate = function () {
            if (desktopQuery.matches) {
                return;
            }

            if (window.scrollY >= threshold) {
                $stickyDonateButton.addClass('sticky-donate-button--visible');
                $stickyDonateWindow.off('scroll.stickyDonate');
                $stickyDonateWindow.off('resize.stickyDonate');
            }
        };

        $stickyDonateWindow.on('scroll.stickyDonate', maybeShowStickyDonate);
        $stickyDonateWindow.on('resize.stickyDonate', maybeShowStickyDonate);
        maybeShowStickyDonate();
    }

    // Hover event handlers for parent menu items
    $('.site-header #primary-menu > li.menu-item-has-children')
        .mouseenter(function () {
            var $parent = $(this);
            var $submenu = $parent.find('> .sub-menu');

            // Close other sub-menus
            $('#primary-menu > li.menu-item-has-children')
                .not($parent)
                .removeClass('submenu-active');
            $('#primary-menu > li.menu-item-has-children')
                .not($parent)
                .find('> .sub-menu')
                .hide();

            // Open hovered sub-menu
            $submenu.show();
            $parent.addClass('submenu-active');
            $parent.parent().addClass('submenu-open');
        })
        .mouseleave(function () {
            var $parent = $(this);
            var $submenu = $parent.find('> .sub-menu');

            // Close sub-menu when mouse leaves
            $submenu.hide();
            $parent.removeClass('submenu-active');

            // Check if any submenu is still active before removing submenu-open
            if ($('#primary-menu > li.submenu-active').length === 0) {
                $parent.parent().removeClass('submenu-open');
            }
        })
        // KEYBOARD ACCESSIBILITY - Focus events
        .on('focusin', function () {
            var $parent = $(this);
            var $submenu = $parent.find('> .sub-menu');

            // Close other sub-menus
            $('#primary-menu > li.menu-item-has-children')
                .not($parent)
                .removeClass('submenu-active');
            $('#primary-menu > li.menu-item-has-children')
                .not($parent)
                .find('> .sub-menu')
                .hide();

            // Open focused sub-menu
            $submenu.show();
            $parent.addClass('submenu-active');
            $parent.parent().addClass('submenu-open');
        })
        .on('focusout', function () {
            var $parent = $(this);
            var $submenu = $parent.find('> .sub-menu');

            // Use setTimeout to allow focus to move to the next element
            setTimeout(function () {
                // Check if focus has moved outside the parent menu item
                if (!$parent.find(':focus').length && !$parent.is(':focus')) {
                    $submenu.hide();
                    $parent.removeClass('submenu-active');

                    // Check if any submenu is still active before removing submenu-open
                    if ($('#primary-menu > li.submenu-active').length === 0) {
                        $parent.parent().removeClass('submenu-open');
                    }
                }
            }, 10);
        });

    // Close menu when clicking outside
    $(document).on('click', function (e) {
        // Check if click is outside the menu
        if (!$(e.target).closest('.menu-primary-container > .menu').length) {
            $(
                '.menu-primary-container > .menu > li.menu-item-has-children'
            ).removeClass('submenu-active');
            $(
                '.menu-primary-container > .menu > li.menu-item-has-children > .sub-menu'
            ).hide();
            $('.menu-primary-container > .menu').removeClass('submenu-open');
        }
    });

    // Prevent clicks inside submenu from closing it
    $('.menu-primary-container > .menu .sub-menu').on('click', function (e) {
        e.stopPropagation();
    });

    // Dropdown Menu Width Adjustment
    if ($(window).width() >= 1100) {
        const mainMenuWidth = $('.menu-primary-container > .menu').outerWidth();
        const buttonWidth = $(
            '.menu-primary-container > .menu > li.menu-item.button--donate'
        ).outerWidth() + $(
            '.menu-primary-container > .menu > li.menu-item.button--play-yellow'
        ).outerWidth();
        $('.menu-primary-container > .menu .sub-menu').css(
            'width',
            mainMenuWidth - buttonWidth + 'px'
        );
    }

    // Update layout on window resize with debouncing
    let resizeTimer;
    $(window).resize(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            // Close Sidr menu when resizing to desktop
            if ($(window).width() >= 1100) {
                $.sidr('close', sidrName);

                const mainMenuWidthResize = $(
                    '.menu-primary-container > .menu'
                ).outerWidth();
                const buttonWidthResize = $(
                    '.menu-primary-container > .menu > li.menu-item.button--donate'
                ).outerWidth() + $(
                    '.menu-primary-container > .menu > li.menu-item.button--play-yellow'
                ).outerWidth();
                $('.menu-primary-container > .menu .sub-menu').css(
                    'width',
                    mainMenuWidthResize - buttonWidthResize + 'px'
                );
            } else {
                $('.menu-primary-container > .menu .sub-menu').css('width', 'auto');
            }
        }, 100);
    });

    // Cache DOM elements
    const $window = $(window);
    const $siteHeader = $('.site-header');
    const $primary = $('#primary');
    const $adminBar = $('#wpadminbar');
    const hasAdminBar = $adminBar.length > 0;

    // Breakpoint
    const DESKTOP_BREAKPOINT = 1100;

    // Fraction of the unscrolled header that should still be visible when
    // it flips to fixed, so the handoff overlaps instead of popping in
    // after the header has already scrolled out of view.
    const HEADER_TRANSITION_OVERLAP_RATIO = 0.4;
    const MIN_SCROLL_THRESHOLD = 20;

    // State tracking
    let currentBreakpoint = null;
    let isScrolled = false;
    let ticking = false;
    let unscrolledHeaderHeight = 0;

    /**
     * Get sidr element (dynamically created by plugin)
     */
    function getSidr() {
        return $('#sidr-main');
    }

    /**
     * Measure the header's unscrolled height. Temporarily drops the
     * .scrolled class (if present) so this stays accurate after a resize
     */
    function measureUnscrolledHeaderHeight() {
        const wasScrolled = $siteHeader.hasClass('scrolled');
        if (wasScrolled) {
            $siteHeader.removeClass('scrolled');
        }
        unscrolledHeaderHeight = $siteHeader.outerHeight() || 0;
        if (wasScrolled) {
            $siteHeader.addClass('scrolled');
        }
    }

    /**
     * Get scroll position (cross-browser, mobile-friendly)
     * jQuery's scrollTop() can be unreliable on mobile devices
     */
    function getScrollTop() {
        return (
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0
        );
    }

    /**
     * Get current layout values
     */
    function getLayoutValues() {
        const headerHeight = $siteHeader.outerHeight() || 0;
        const adminHeight = hasAdminBar ? $adminBar.outerHeight() : 0;
        const isDesktop = $window.width() > DESKTOP_BREAKPOINT;
        // Mobile header height (no shrink) — start the transition immediately.
        const scrollThreshold = isDesktop
            ? Math.max(
                  unscrolledHeaderHeight * (1 - HEADER_TRANSITION_OVERLAP_RATIO),
                  MIN_SCROLL_THRESHOLD
              )
            : 0;
        return {
            headerHeight,
            adminHeight,
            isDesktop,
            scrollThreshold,
        };
    }

    /**
     * Apply layout styles
     */
    function applyLayout(scrolled) {
        const { headerHeight, adminHeight, isDesktop } = getLayoutValues();
        const $sidr = getSidr();
        const sidrTop = adminHeight + headerHeight;

        if (scrolled) {
            // Reserve exactly the space the header occupied in normal flow
            // before it went fixed so the content doesn't jump down when it flips to fixed.
            const scrolledMarginTop = unscrolledHeaderHeight;
            if (isDesktop) {
                $primary.css('margin-top', scrolledMarginTop + 'px');
                $siteHeader.css('margin-top', adminHeight + 'px');
            } else {
                $siteHeader.css('margin-top', '0px');
                $primary.css('margin-top', scrolledMarginTop + 'px');
                $sidr.css('top', headerHeight + 'px');
            }
        } else {
            $siteHeader.css('margin-top', '0px');
            $primary.css('margin-top', '0px');
            $sidr.css('top', sidrTop + 'px');
        }
    }

    /**
     * Sync scroll state with current scroll position (used on load/resize).
     */
    function syncScrollState() {
        const { scrollThreshold } = getLayoutValues();
        const scrollTop = getScrollTop();
        isScrolled = scrollTop > scrollThreshold;
        $siteHeader.toggleClass('scrolled', isScrolled);
        applyLayout(isScrolled);
    }

    /**
     * Handle scroll state changes
     */
    function updateScrollState() {
        const { scrollThreshold } = getLayoutValues();
        const scrollTop = getScrollTop();
        const shouldBeScrolled = scrollTop > scrollThreshold;

        if (shouldBeScrolled !== isScrolled) {
            isScrolled = shouldBeScrolled;
            $siteHeader.toggleClass('scrolled', isScrolled);
            applyLayout(isScrolled);
        }

        ticking = false;
    }

    /**
     * Throttled scroll handler using requestAnimationFrame
     */
    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(updateScrollState);
            ticking = true;
        }
    }

    /**
     * Handle breakpoint changes
     */
    function updateBreakpoint() {
        const { isDesktop } = getLayoutValues();
        const newBreakpoint = isDesktop ? 'desktop' : 'mobile';

        if (newBreakpoint !== currentBreakpoint) {
            currentBreakpoint = newBreakpoint;

            // Re-evaluate scroll state with new threshold
            const { scrollThreshold } = getLayoutValues();
            const scrollTop = getScrollTop();
            isScrolled = scrollTop > scrollThreshold;

            $siteHeader.toggleClass('scrolled', isScrolled);
        }
    }

    /**
     * Full layout recalculation
     */
    function recalculateLayout() {
        measureUnscrolledHeaderHeight();
        updateBreakpoint();
        syncScrollState();
    }

    /**
     * Debounce helper
     */
    function debounce(func, wait) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, arguments), wait);
        };
    }

    // Event handlers
    const debouncedResize = debounce(recalculateLayout, 100);

    // Bind scroll with passive listener and rAF throttling for mobile performance
    window.addEventListener('scroll', onScroll, { passive: true });
    $window.on('resize', debouncedResize);

    // Handle orientation change on mobile
    window.addEventListener(
        'orientationchange',
        function () {
            setTimeout(recalculateLayout, 100);
        },
        { passive: true }
    );

    // Initialize on load and when Firefox restores scroll position from bfcache.
    recalculateLayout();
    window.addEventListener('pageshow', function () {
        recalculateLayout();
    });
});